:root {
	--agro-primary: #7fb02f;
	--agro-primary-hover: #6fa72b;
	--agro-primary-weak: rgba(46, 125, 50, 0.2);
}

.wrapper {
	position: relative;
	display: inline-block;
	max-width: 100%;
}

.readButton {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	background: transparent;
	border: 0;
	padding: 0;
	margin: 0;
	color: var(--agro-primary, #1f6feb);
	cursor: pointer;
	transition:
		color 120ms ease-in-out,
		opacity 120ms ease-in-out;
}
.readButton:hover {
	color: var(--agro-primary-hover, #1158c7);
}
.readButton:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}
.readText {
	line-height: 1.2;
	color: #111827;
}
.readIcon {
	width: 14px;
	height: 14px;
	stroke-width: 2;
	opacity: 0.9;
}

.popover {
	position: absolute;
	top: -8px;
	left: -8px;
	z-index: 20;
	min-width: 320px;
	max-width: 420px;
	background: #fff;
	border: 1px solid #d1d5db;
	border-radius: 10px;
	box-shadow:
		0 1px 2px rgba(0, 0, 0, 0.06),
		0 4px 12px rgba(0, 0, 0, 0.12);
	padding: 10px;
}

.inlineEdit {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;
}

.input {
	border: 1px solid #d1d5db;
	border-radius: 8px;
	padding: 6px 8px;
	font-size: 14px;
	line-height: 1.25;
	outline: none;
	transition:
		box-shadow 120ms ease,
		border-color 120ms ease,
		background-color 120ms ease;
	background-color: #fff;
	min-width: 220px;
	width: 100%;
}
.input:focus {
	border-color: var(--agro-primary, #1f6feb);
	box-shadow: 0 0 0 3px var(--agro-primary-weak, rgba(31, 111, 235, 0.2));
}
.input:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.actions {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-top: 8px;
}

.btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
	line-height: 1.2;
	padding: 6px 10px;
	border: 1px solid transparent;
	cursor: pointer;
	transition:
		background-color 120ms ease,
		color 120ms ease,
		border-color 120ms ease,
		opacity 120ms ease;
	user-select: none;
}

.saveButton {
	composes: btn;
	order: 1;
	background-color: var(--agro-primary, #1f6feb);
	color: #fff;
	border-color: var(--agro-primary, #1f6feb);
}
.saveButton:hover {
	background-color: var(--agro-primary-hover, #1158c7);
	border-color: var(--agro-primary-hover, #1158c7);
}
.saveButton:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.cancelButton {
	composes: btn;
	order: 0;
	background-color: #f8fafc;
	color: #374151;
	border-color: #d1d5db;
}
.cancelButton:hover {
	background-color: #f3f4f6;
	border-color: #c7cdd6;
}

.actionIcon {
	width: 16px;
	height: 16px;
	stroke-width: 2;
}

.errorText {
	margin-top: 6px;
	color: #dc2626;
	font-size: 12px;
}
